module.exports = __webpack_public_path__ + "img/loading.7b6b969a.gif";